import { render, staticRenderFns } from "./activityManageRoles.html?vue&type=template&id=45fb2572&scoped=true&"
import script from "./activityManageRoles.vue?vue&type=script&lang=js&"
export * from "./activityManageRoles.vue?vue&type=script&lang=js&"
import style0 from "./activityManageRoles.css?vue&type=style&index=0&id=45fb2572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb2572",
  null
  
)

export default component.exports